import { AutocompleteFilter } from "./AutocompleteFilter";
import { Entity } from "../../filters/filter.types";
import { titleCase } from "portal/utils/strings";
import { UiPredictionPointSessionFilters } from "portal/utils/categoryCollection/predictionPoints";
import { useTranslation } from "react-i18next";
import React, { FunctionComponent } from "react";

export type SessionFilters = Omit<UiPredictionPointSessionFilters, "sessionId">;

interface SessionFilterProps {
  categoryOptions: Entity[];
  filters: SessionFilters;
  onChange: (filters: SessionFilters) => void;
}

export const SessionFilters: FunctionComponent<SessionFilterProps> = ({
  categoryOptions,
  filters,
  onChange,
}) => {
  const { t } = useTranslation();
  return (
    <AutocompleteFilter
      label={titleCase(t("models.categoryCollectionProfiles.category_other"))}
      options={categoryOptions}
      value={filters.categoryIds}
      onChange={(value) => onChange({ categoryIds: value })}
    />
  );
};
